import { formatDate, formatName } from "../../../../utils/common-utils";
import PlaceholderImage from "./place-holder-img.svg";

export const prepareReviewList = ({ content }) => {
  const reviewList = [];

  content.forEach((reviewItem) => {
    const { id, review, rating, consumer, updatedAt } = reviewItem;
    const { firstName, lastName, profilePicUrl } = consumer;

    reviewList.push({
      id,
      imgRow: {
        imgSrc: profilePicUrl || PlaceholderImage,
        title: formatName({ firstName, lastName }),
      },
      rating,
      review,
      dateTime: formatDate(updatedAt),
      reviewClass: !profilePicUrl ? "empty-review-shadow" : "",
    });
  });

  return reviewList;
};



export const setColSize1 = (resizeWidth) => {
  switch (true) {
    case resizeWidth < 400:
      return 6;
    case resizeWidth < 500:
      return 5;
    case resizeWidth < 900:
      return 4;
    case resizeWidth < 1245:
      return 3;
    default:
      return 2;
  }
};

export const setColSize2 = (resizeWidth) => {
  switch (true) {
    case resizeWidth < 400:
      return 18;
    case resizeWidth < 500:
      return 19;
    case resizeWidth < 900:
      return 20;
    case resizeWidth < 1245:
      return 21;
    default:
      return 22;
  }
};

export const setListColSize1 = (resizeWidth) => {
  switch (true) {
    case resizeWidth < 400:
      return 5;
    case resizeWidth < 500:
      return 4;
    case resizeWidth < 900:
      return 3;
    case resizeWidth < 1245:
      return 2;
    default:
      return 1;
  }
};

export const setListColSize2 = (resizeWidth) => {
  switch (true) {
    case resizeWidth < 400:
      return 19;
    case resizeWidth < 500:
      return 20;
    case resizeWidth < 900:
      return 21;
    case resizeWidth < 1245:
      return 22;
    default:
      return 23;
  }
};
